<template>
  <div class="whatsapp-widget">
    <a 
      :href="whatsappLink" 
      target="_blank" 
      rel="noopener noreferrer" 
      class="whatsapp-button"
      title="Chatea con nosotros en WhatsApp"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <svg 
        viewBox="0 0 32 32" 
        class="whatsapp-icon"
      >
        <path fill="currentColor" d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.924 0-7.435 6.050-13.485 13.485-13.485s13.485 6.050 13.485 13.485c0 7.435-6.050 13.485-13.485 13.485zM21.960 18.828c-0.296-0.148-1.757-0.868-2.030-0.967-0.272-0.099-0.47-0.148-0.669 0.148s-0.768 0.967-0.941 1.165c-0.173 0.198-0.347 0.223-0.644 0.074-0.297-0.148-1.253-0.462-2.387-1.475-0.883-0.788-1.479-1.761-1.653-2.059s-0.018-0.458 0.13-0.606c0.134-0.133 0.297-0.347 0.446-0.521s0.198-0.297 0.297-0.495c0.099-0.198 0.050-0.372-0.025-0.521s-0.669-1.611-0.916-2.206c-0.242-0.579-0.487-0.501-0.669-0.51-0.173-0.008-0.372-0.010-0.571-0.010s-0.52 0.074-0.793 0.372c-0.272 0.297-1.040 1.016-1.040 2.479s1.065 2.876 1.213 3.074c0.148 0.198 2.095 3.2 5.076 4.487 0.709 0.306 1.263 0.489 1.694 0.626 0.712 0.226 1.36 0.194 1.872 0.118 0.571-0.085 1.758-0.719 2.006-1.413s0.248-1.289 0.173-1.413c-0.074-0.124-0.272-0.198-0.570-0.347z"/>
      </svg>
      <span v-if="isHovered || showMessage" class="whatsapp-tooltip">
        ¡Chatea con nosotros!
      </span>
    </a>
  </div>
</template>

<script src="./WhatsAppWidget.js"></script>
<style src="./WhatsAppWidget.css"></style>
